import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import "./HomeBarner.css";
import { MdDateRange, MdHome, MdLocationOn, MdTimer } from 'react-icons/md';
import { FaCarRear } from 'react-icons/fa6';
import Aos from 'aos';
import { localStorageData, localStorageKeys } from '../../../utils/storage/localvalue';
import { dureeDeVie, setWithExpiration } from '../../../utils/storage/localvalueFuction';
import axios from 'axios';
import { baseurl } from '../../../utils/url/baseurl';
import { useState } from 'react';
import { ROUTES } from '../../../config/routingUrl';
import { useNavigate } from 'react-router-dom';
import { saveDataToFile } from '../../../actions/DataLocal';
import { toast } from 'react-toastify';
import { RxDoubleArrowDown } from 'react-icons/rx';
import 'aos/dist/aos.css';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Select from "react-select";



// Création des options d'heures avec intervalles de 30 minutes
export const hourOptions = Array.from({ length: 24 }, (_, i) => {
  const hour = i.toString().padStart(2, '0');
  return [
    { value: `${hour}:00`, label: `${hour}:00` },
    { value: `${hour}:30`, label: `${hour}:30` }
  ];
}).flat();


// Initialiser AOS
Aos.init({
  duration: 1000, // Durée de l'animation
  easing: 'ease-in-out', // Effet de transition
  once: true, // L'animation ne se joue qu'une seule fois
});


const HomeBarner = () => {

  const navigate = useNavigate();



  const [formData, setFormData] = useState({
    agenceDepart: '',
    dateDepart: '',
    heureDepart: { value: '10:00', label: '10:00' },
    dateRetour: '',
    heureRetour: { value: '10:00', label: '10:00' },
    agePlus25: false,
    lat: "",
    lng: "",
    patrimoine: "Vehicle"
  });

  // État pour gérer la visibilité du calendrier
  const [showDatePicker, setShowDatePicker] = useState(false);

  // Fonction pour gérer les changements dans les champs du formulaire
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Gestion de la sélection des heures
  const handleHourChange = (selectedOption, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: selectedOption,
    }));
  };

  // Fonction pour combiner les dates et heures en un objet Date au format ISO 8601
  const combineDateAndTime = (date, time) => {
    const [hours, minutes] = time.value.split(':');
    const combined = new Date(date);
    combined.setHours(hours);
    combined.setMinutes(minutes);
    combined.setSeconds(0);
    combined.setMilliseconds(0);
    return combined.toISOString(); // Convertir en format ISO 8601
  };

  // Gestion de la soumission du formulaire
  const [formErrors, setformErrors] = useState({
    agenceDepArt: "",
    date: "",
    horaire: "",
  });

  const validateForm = () => {
    let errors = {};

    // Validation de l'agence de départ
    if (!formData.agenceDepart) {
      errors.agenceDepArt = "La localisation du lieu est requise";
      toast.error("La localisation du lieu est requise", { position: "bottom-right" });
    }

    // Validation de la date de départ
    if (!formData.dateDepart) {
      errors.date = "La date de départ est obligatoire";
      toast.error("La date de départ est obligatoire", { position: "bottom-right" });
    } else if (isNaN(Date.parse(formData.dateDepart))) {
      errors.date = "Le format de la date de départ est invalide";
      toast.error("Le format de la date de départ est invalide", { position: "bottom-right" });
    }

    // Validation de la date de retour
    if (!formData.dateRetour) {
      errors.date = "La date de retour est obligatoire";
      toast.error("La date de retour est obligatoire", { position: "bottom-right" });
    } else if (isNaN(Date.parse(formData.dateRetour))) {
      errors.date = "Le format de la date de retour est invalide";
      toast.error("Le format de la date de retour est invalide", { position: "bottom-right" });
    }

    // Validation de l'heure de départ
    if (!formData.heureDepart) {
      errors.horaire = "L'heure de départ est obligatoire";
      toast.error("L'heure de départ est obligatoire", { position: "bottom-right" });
    }

    // Validation de l'heure de retour
    if (!formData.heureRetour) {
      errors.horaire = "L'heure de retour est obligatoire";
      toast.error("L'heure de retour est obligatoire", { position: "bottom-right" });
    }

    // Mise à jour des erreurs
    setformErrors(errors);

    // Retourne true si aucune erreur n'est détectée
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      try {
        // Mettre à jour les valeurs locales
        setWithExpiration(localStorageKeys.dateDepart, formData.dateDepart, dureeDeVie);
        setWithExpiration(localStorageKeys.dateRetour, formData.dateRetour, dureeDeVie);

        // Sauvegarder les données dans un fichier
        saveDataToFile(formData.heureDepart, localStorageData.heureDepart);
        saveDataToFile(formData.heureRetour, localStorageData.heureRetour);

        // Combinaison de la date et de l'heure
        const startDateTime = combineDateAndTime(formData.dateDepart, formData.heureDepart);
        const endDateTime = combineDateAndTime(formData.dateRetour, formData.heureRetour);

        // Navigation vers la page de résultats
        navigate(`/${ROUTES.RESULTS_PAGE}`, { state: { startDateTime, endDateTime, ...formData } });
      } catch (error) {
        toast.error("Veuillez renseigner tous les champs du formulaire", { position: "bottom-right" });
      }
    }
  };

  // Empêcher la sélection de dates passées
  // Récupérer la date actuelle
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Calculer la date minimale pour la date de retour (2 jours après la date de départ)
  const minReturnDate = formData.dateDepart
    ? new Date(formData.dateDepart.getTime() + 1 * 24 * 60 * 60 * 1000)
    : null;

  // Vérifier que la date de retour est supérieure ou égale à la date de départ
  const isDateRetourValid = formData.dateRetour >= formData.dateDepart;


  const [pickupLocation, setPickupLocation] = useState('');
  const [pickupSuggestions, setPickupSuggestions] = useState([]);

  // Obtenir les suggestions de lieu de départ
  const getPlacesByCountryStartLocation = async (query) => {
    try {
      const response = await axios.get(`${baseurl.url}/api/v1/places`, {
        params: { query: query },
      });
      const places = response.data.results;
      return places.map(place => place);
    } catch (error) {
      console.error("Erreur lors de la récupération des lieux : ", error);
    }
  };

  const handlePickupLocationChange = async (e) => {
    const value = e.target.value;
    setPickupLocation(value);
    if (value.length > 2) {
      const suggestions = await getPlacesByCountryStartLocation(value);
      setPickupSuggestions(suggestions);
    } else {
      setPickupSuggestions([]); // Réinitialiser la liste des suggestions
    }
  };

  const handlePickupSelection = (suggestion) => {
    setPickupLocation(`${suggestion.name} - ${suggestion.formatted_address}`);
    setFormData(prevState => ({
      ...prevState,
      agenceDepart: `${suggestion.name} - ${suggestion.formatted_address}`,
      lat: suggestion?.geometry?.location?.lat,
      lng: suggestion?.geometry?.location?.lng
    }));

    setWithExpiration(localStorageKeys.agenceDepArt, `${suggestion.name} - ${suggestion.formatted_address}`, dureeDeVie);
    setWithExpiration(localStorageKeys.agenceRetour, `${suggestion.name} - ${suggestion.formatted_address}`, dureeDeVie);
    setWithExpiration(localStorageKeys.latSelect, suggestion?.geometry?.location?.lat, dureeDeVie);
    setWithExpiration(localStorageKeys.longSelect, suggestion?.geometry?.location?.lng, dureeDeVie);
    setWithExpiration(localStorageKeys.latSelectRetour, suggestion?.geometry?.location?.lat, dureeDeVie);
    setWithExpiration(localStorageKeys.longSelectRetour, suggestion?.geometry?.location?.lng, dureeDeVie);

    setPickupSuggestions([]);
  };



  const handleCleanSugestions = () => {
    setPickupSuggestions([]);
  };

  const imageBg = "design/images/Map.png";
  const imageBgTransaition1 = "design/images/Toyota_Camry_Home.png";
  const imageBgTransaition2 = "design/images/Property.png";

  const [patrimoineChoice, setpatrimoineChoice] = useState("Vehicle");

  useEffect(() => {
    // Initialiser AOS
    Aos.init({
      duration: 1000, // Durée de l'animation
      once: true, // L'animation ne se joue qu'une seule fois
    });
  }, []);

  const scrollToBottom = () => {
    window.scrollBy({
      top: 150, // Défile de 50 pixels vers le bas
      behavior: 'smooth' // Animation fluide
    });
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);





  return (
    <div className="container-fluid container-barner-home-section" style={{ padding: "150px 5px 0px 0px", position: "relative" }} onClick={handleCleanSugestions} >
      <div style={{ position: "relative", zIndex: 60 }} className="container" >
        <div style={{ display: "flex", flexDirection: !isMobile ? "row" : "column", transition: "1s" }}>
          {
            formData.patrimoine == "Vehicle" ?
              <div className="container-barner-home-section-card" style={{ width: "100%", paddingBottom: "80px", position: "relative", zIndex: 60 }}
                data-aos="fade-down" data-aos-duration="1000" >
                <div>
                  <h1 style={{ color: "#595959", fontSize: "40px" }} data-aos="fade-down" data-aos-duration="1000"  >Trouvez le véhicule idéal avec Mareza</h1>
                </div>
                <div style={{ paddingTop: "20px" }}>
                  <span style={{ color: "#737373" }} data-aos="fade-down" data-aos-duration="1000" >
                    Avec Mareza, economisez votre temps, réservez votre véhicule
                    <br />
                    en ligne en toute sérénité.
                  </span>
                </div>
                <div style={{ marginTop: "20px", boxShadow: "0px 0px 2.5px #42B711", cursor: "pointer" }} onClick={() => { navigate(`/${ROUTES.CAR_LIST_WEB}`) }} className="container-barner-home-section-button-explore">
                  <div>Explorer les offres</div>
                </div>
              </div>
              :
              <div className="container-barner-home-section-card" style={{ width: "100%", paddingBottom: "80px", position: "relative", zIndex: 60 }}
                data-aos="fade-down" data-aos-duration="1000" >
                <div>
                  <h1 style={{ color: "#595959", fontSize: "40px" }} data-aos="fade-down" data-aos-duration="1000"  >Trouvez la propriété idéale avec Mareza! </h1>
                </div>
                <div style={{ paddingTop: "20px" }}>
                  <span style={{ color: "#737373" }} data-aos="fade-down" data-aos-duration="1000" >
                    Gagnez du temps avec Mareza : réservez votre hébergement en toute tranquillité,
                    <br />
                    où que vous soyez.
                  </span>
                </div>
                <div style={{ marginTop: "20px", boxShadow: "0px 0px 2.5px #42B711", cursor: "pointer" }} onClick={() => { navigate(`/${ROUTES.CAR_LIST_WEB}`) }} className="container-barner-home-section-button-explore">
                  <div>Explorer les offres</div>
                </div>
              </div>
          }
          <div className="container-barner-home-section-card-image" style={{
            width: "100%",
            background: "transparent",
            border: "none",
            boxShadow: "none",
            filter: "drop-shadow(0px 0px 5px rgba(0,0,0,0.3))", backgroundImage: imageBg, paddingTop: "-20px",
          }}>
            <div style={{ position: "relative" }}>
              <div style={{ display: isMobile ? "none" : "", position: isMobile ? "relative" : "absolute", zIndex: 100, top: isMobile ? "0%" : 52, right: isMobile ? 0 : "5%" }}>
                <div style={{ display: "flex", height: "200px", }}>
                  <div><MdLocationOn className="text-primary" size={25} /></div>
                  <div style={{ position: "relative" }}><img src="design/images/icons/file_location.png" style={{ rotate: "0deg", margin: "-30px 0px 0px 0px", width: "100px" }} /></div>
                  <div><MdLocationOn className="text-primary" size={25} /></div>
                  <div> <img src="design/images/icons/file_location.png" style={{ rotate: "160deg", marginBottom: "-10%", width: "100px" }} /></div>
                  <div><MdLocationOn className="text-primary" size={25} style={{ margin: "-80px 0px 0px 0px" }} /></div>
                </div>
              </div>
              {formData.patrimoine == "Vehicle" ? (
                <img
                  data-aos="fade-down"
                  data-aos-duration="1000"
                  style={{
                    display: isMobile ? "none" : "",
                    position: "absolute",
                    top: 150,
                    zIndex: 55,
                    width: "100%",
                    transition: "1s"
                  }}
                  className="img-fluid"
                  src={imageBgTransaition1}
                  alt=""
                />
              ) : (
                <img
                  data-aos="fade-down"
                  data-aos-duration="1000"
                  style={{
                    display: isMobile ? "none" : "",
                    position: "absolute",
                    top: 50,
                    zIndex: 55,
                    width: "100%",
                    transition: "1s"
                  }}
                  className="img-fluid"
                  src={imageBgTransaition2}
                  alt=""
                />
              )}
            </div>
          </div>


        </div>
        {
          !isMobile && (
            <div style={{ position: "absolute", left: "45%", bottom: "-20%", trans: "1s" }}>
              <div style={{ cursor: "pointer", padding: "10px", borderRadius: "50%", border: "1px #43B613 solid", boxShadow: "0px 0px 2.5px #42B711" }}
                data-aos="fade-up"
                data-aos-delay="300"
                onClick={scrollToBottom}
              >
                <RxDoubleArrowDown className="text-white" />
              </div>
            </div>
          )
        }


      </div >

      <img style={{ position: "absolute", zIndex: 50, top: 100, right: 0 }} src="design/images/Map.png" alt="" />
      {/*Section de l'élement important */}
      {
        !isMobile && (

          <div className="container-fluid container-barner-home-section-horaire">
            <div className="conatiner container-barner-home-section-horaire-card">
              <div className={`${formData.patrimoine == "Vehicle" ? "container-barner-home-section-horaire-card-button-patrimoine-active" :
                "container-barner-home-section-horaire-card-button-patrimoine"}`} style={{ cursor: "pointer" }}
                onClick={() => { setFormData({ ...formData, patrimoine: "Vehicle" }) }}><FaCarRear size={15} /> <span > Recherchez un véhicule</span> </div>
              <div className={`${formData.patrimoine == "Property" ? "container-barner-home-section-horaire-card-button-patrimoine-active" :
                "container-barner-home-section-horaire-card-button-patrimoine"}`} style={{ cursor: "pointer" }}
                onClick={() => { setFormData({ ...formData, patrimoine: "Property" }) }}><MdHome size={15} /> <span > Recherchez une propriété</span> </div>
            </div>
            <div className="container-barner-home-section-horaire-card-2">
              <div className="row " >
                <div className="col-md-2" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px" }}>
                  <div style={{ color: "#737373" }}>Localisation</div>
                  <div style={{ color: "#D9D9D9", display:"flex" }} className="position-relative">
                    <MdLocationOn size={25} style={{ marginTop:"10px" }} />
                    <span>
                      <input
                        className={`bg-transparent  ${isMobile ? "border-0 border-bottom" : "border-0 border-bottom"}`} style={{ color: "#737373", border: "0px 0px 1px 0px #737373 solid", padding: "3px", marginTop:"10px" }}
                        value={pickupLocation}
                        onChange={handlePickupLocationChange}
                        placeholder='Lieu en Algerie'
                      />

                      {formErrors.agenceDepArt && (<div className="text-danger">{formErrors.agenceDepArt}</div>)}
                      {pickupSuggestions && pickupSuggestions.length > 0 && (
                        <ul className="rounded p-1 border" style={{ position: 'absolute', zIndex: 1000, backgroundColor: 'white', maxWidth: "400px", listStyleType: 'none', padding: 0, maxHeight: "200px", overflow: "auto" }}>
                          {pickupSuggestions.map((suggestion, index) => (
                            <li className="border"
                              key={index}
                              style={{ padding: '5px', cursor: 'pointer', color: "#737373" }}
                              onClick={() => handlePickupSelection(suggestion)}
                            >
                              <MdLocationOn /> {`${suggestion.name} - ${suggestion.formatted_address}`}
                            </li>
                          ))}
                        </ul>
                      )}
                    </span>
                  </div>
                </div>
                {/* Section Dates */}
                <div className="col-md-5" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px" }}>
                  {/* Étiquette */}
                  <div style={{ color: "#737373" }}>Dates</div>

                  {/* Clic pour afficher/masquer le calendrier */}
                  <div
                    style={{
                      color: "#D9D9D9",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowDatePicker(!showDatePicker)}
                  >
                    <MdDateRange size={25} style={{marginTop:"10px"  }} />
                    <div >
                      <div style={{ marginTop: "10px", display: "flex", flexDirection: isMobile ? "column" : "row", gap: "5px" }}>
                        {/* Sélecteur de date pour la date de départ */}
                        <DatePicker
                          locale={"fr"}
                          selected={formData.dateDepart}
                          onChange={(date) =>
                            setFormData({
                              ...formData,
                              dateDepart: date,
                              dateRetour: null, // Réinitialiser la date de retour si la date de départ change
                            })
                          }
                          selectsStart
                          minDate={today} // Griser les dates passées
                          placeholderText="Date de départ"
                          dateFormat="dd-MM-yyyy"
                          className={`bg-transparent  ${isMobile ? "border-0 border-bottom" : ""}`}
                          style={{ height: "30px", width: "40px", borderRadius: "5px", }}
                        />

                        {/* Sélecteur de date pour la date de retour */}
                        <DatePicker
                          locale={"fr"}
                          selected={formData.dateRetour}
                          onChange={(date) => setFormData({ ...formData, dateRetour: date })}
                          selectsEnd
                          startDate={formData.dateDepart}
                          endDate={formData.dateRetour}
                          minDate={minReturnDate} // Limiter les dates de retour à 2 jours après la date de départ
                          placeholderText="Date de retour"
                          dateFormat="dd-MM-yyyy"
                          className={`bg-transparent  ${isMobile ? "border-0 border-bottom" : ""}`}
                          style={{ height: "30px", width: "40px", borderRadius: "5px" }}
                          disabled={!formData.dateDepart} // Désactiver tant que la date de départ n'est pas sélectionnée
                        />
                      </div>
                    </div>
                  </div>
                  {formErrors.date && (<div className="text-danger">{formErrors.date}</div>)}
                </div>

                {/* Section Horaire */}
                <div className="col-md-3" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px" }}>

                  <div
                    style={{
                      color: "#D9D9D9",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div style={{ gap: "5px" , alignItems:"end" }}>
                      <MdTimer size={25} style={{ marginTop:"30px" }} />
                    </div>
                    <div style={{ display: "flex",gap:"2px" }}>
                      <div style={{ gap: "2px" }}>
                        {/* Sélecteur d'heure pour l'heure de départ */}
                        <label style={{ color: "#737373" }}>Départ</label>
                        <Select
                          value={formData.heureDepart}
                          onChange={(selectedOption) =>
                            setFormData({ ...formData, heureDepart: selectedOption })
                          }
                          options={hourOptions}
                          placeholder="Choix"
                          styles={{

                            control: (baseStyles) => ({
                              ...baseStyles,
                              height: "20px",
                              borderRadius: "5px",
                              color: "black"
                            }),
                            menuList:(baseStyles) => ({
                              ...baseStyles,
                              borderRadius: "5px",
                              color: "black"
                            }),
                            
                          }}
                        />
                      </div>

                      {/* Sélecteur d'heure pour l'heure de retour */}
                      <div style={{ gap: "2px", color:"black" }}>
                        <label style={{ color: "#737373" }}>Fin</label>
                        <Select
                          value={formData.heureRetour}
                          onChange={(selectedOption) =>
                            setFormData({ ...formData, heureRetour: selectedOption })
                          }
                          options={hourOptions}
                          placeholder="Choix"
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              height: "20px",
                              borderRadius: "5px",
                              color: "black"
                            }),
                            menuList:(baseStyles) => ({
                              ...baseStyles,
                              borderRadius: "5px",
                              color: "black"
                            })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {formErrors.horaire && (<div className="text-danger">{formErrors.horaire}</div>)}
                </div>

                <div className="col-md-2" style={{ padding: isMobile ? "10px 0px 0px 0px" : "0px", alignContent: "center" }}>
                  <Button variant="primary" style={{ borderRadius: "50px", padding: "10px 15px 10px 15px", marginTop:"10px" }} onClick={handleSubmit}>Rechercher</Button>
                </div>
              </div>
            </div>
          </div>
        )
      }


    </div >
  );
};

export default HomeBarner;
